export default __webpack_public_path__ + "static/media/success.ae90eb20.png";